/*
 *
 * OperationLoyalty
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 24-Jul-2025
 */

import OperationLoyalty from './OperationLoyaltyContainer'

export default OperationLoyalty
